import _ from 'lodash';

export const flattenTree = (arr, nestingKey) => {
  let flatTree = [];
  arr.forEach(a => {
    flatTree.push(a);
    if (Array.isArray(a[nestingKey])) {
      flatTree = flatTree.concat(flattenTree(a[nestingKey], nestingKey));
    }
  });

  return flatTree;
};

export const getSelectedOptions = (flatTree = [], selected = []) => {
  const selectedOptions = flatTree.filter(({ value }) =>
    selected.includes(value)
  );

  return selectedOptions;
};

export const renderSelectedDefault = (selected = []) => {
  return selected.length > 1
    ? `${selected.length} selected`
    : _.get(selected, '[0].displayValue', '');
};

export const renderSelectedNotFoundDefault = (
  selectedId = [],
  selectedIdsNotInTree = []
) => {
  if (selectedId.length > 1) {
    return `${selectedId.length} selected`;
  }

  return 'Selected item not in dropdown';
};
